import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ID_SYSTEM_CONFIG, IdSystemConfig, IdSystemService, UserDataDetail } from '.';
import { Observable, map } from 'rxjs';
import { TradeKey } from '../../model/api';

@Injectable({
  providedIn: 'root'
})
export class IdSystemUserService {

  private http = inject(HttpClient)
  private config = inject<IdSystemConfig>(ID_SYSTEM_CONFIG)
  private idSystem = inject(IdSystemService)

  getAccountDetail() {
    return this.get<UserDataDetail>('/account/detail')
  }

  setEmail(email: string, password?: string) {
    return this.post('/account/email/set', {
      'email': email,
      'password': password,
      'redirect_uri': location.href,
    })
  }

  verifyEmail() {
    return this.post('/account/email/verify', {
      'redirect_uri': location.href,
    })
  }

  setPassword(newPassword: string) {
    return this.post('/account/password/set', {
      'new_password': newPassword,
    })
  }

  changePassword(newPassword: string, oldPassword: string) {
    return this.post('/account/password/change', {
      'new_password': newPassword,
      'old_password': oldPassword,
    })
  }

  linkBot(bot: string) {
    return this.post('/account/telegram/link-bot', {
      'bot': bot,
    })
  }

  unlinkBot(bot: string) {
    return this.post('/account/telegram/unlink-bot', {
      'bot': bot,
    })
  }

  getApiKeys() {
    return this.get<TradeKey[]>('/api-key/get-keys', {
      'type': 'crypto'
    }).pipe(
      // Фильтруем только ключи binance, bybit, okx
      map(keys => keys.filter(key => ['binance','bybit','okx'].includes(key.market)))
    )
  }

  private get<T = unknown>(url: string, params?: Record<string, string | number | boolean | readonly (string | number | boolean)[]>): Observable<T> {
    return this.http.get<T>(this.buildUrl(url), {
      params: {
        ...params,
        'client_id': this.config.clientId,
      },
      headers: {Authorization: `Bearer ${this.idSystem.accessToken}`}
    })
  }

  private post<T = unknown, D = Record<string, unknown>>(url: string, data: D): Observable<T> {
    return this.http.post<T>(this.buildUrl(url), {
      ...data,
      'client_id': this.config.clientId,
    }, {
      headers: {Authorization: `Bearer ${this.idSystem.accessToken}`}
    })
  }

  private buildUrl(path: string) {
    return `${this.config.apiUrl}/user/${path.replace(/^\//, '')}`
  }
}
